import { batch } from '@tmapy/redux';
import { LAYER_TYPE, LAYER_IDS, EDIT_TOOLS_MIX_HALO } from '@tmapy/config';
import { actionInteractionSelectFeatures, actionSetLayerFeatures, actionSetLayerMapboxStyle, featureToGeoJSONObject, getMergedMapboxStyles, } from '@tmapy/mapcore';
import { actionUnhideTileAllFeaturesByLayer } from './actionUnhideTileFeaturesByLayer';
export const actionSelectFeature = (payload) => (dispatch, getState) => {
    const state = getState();
    const editLayer = state.mapCore.layers.find((layer) => layer.type === LAYER_TYPE.VECTOR && layer.id === LAYER_IDS.EDIT_TOOLS_MODIFY);
    const lastEditFeatures = editLayer?.features ?? [];
    const lastEditedLayer = lastEditFeatures[0]?.properties?._originLayerId;
    lastEditFeatures.forEach((feature) => {
        if (feature.properties?._originLayerId !== lastEditedLayer) {
            console.error('actionSelectFeature: features have different originLayerId!');
        }
    });
    const editedLayerFeatures = payload.features.filter((layerFeature) => layerFeature.layerId === LAYER_IDS.EDIT_TOOLS_HIGHLIGHT);
    const editedOLFeatures = editedLayerFeatures.map((layerFeature) => layerFeature.feature);
    const geoJSONFeatures = editedOLFeatures.map(featureToGeoJSONObject);
    batch('actionSelectFeature', () => {
        if (lastEditedLayer) {
            dispatch(actionUnhideTileAllFeaturesByLayer(LAYER_IDS.EDIT_TOOLS_MODIFY, lastEditedLayer));
        }
        dispatch(actionSetLayerFeatures(LAYER_IDS.EDIT_TOOLS_HIGHLIGHT, []));
        dispatch(actionSetLayerFeatures(LAYER_IDS.EDIT_TOOLS_MODIFY, geoJSONFeatures));
        // mapbox styles mix
        const featureLayerConfig = state.mapCore.layers.find((layer) => (layer.type === LAYER_TYPE.VECTOR || layer.type === LAYER_TYPE.TILE_VECTOR) &&
            layer.id === editedOLFeatures[0]?.get?.('_originLayerId'));
        if (featureLayerConfig && featureLayerConfig.mapboxStyle) {
            const mergedMapboxStyles = getMergedMapboxStyles(LAYER_IDS.EDIT_TOOLS_MODIFY, featureLayerConfig, { feature: editedOLFeatures[0] }, EDIT_TOOLS_MIX_HALO);
            if (mergedMapboxStyles) {
                dispatch(actionSetLayerMapboxStyle(LAYER_IDS.EDIT_TOOLS_MODIFY, mergedMapboxStyles));
            }
        }
    });
    /**
     * TODO - refactor effects vs. middleware ?
     * nastava problem s navazujicim useEffect (mapcore/VectorTileLayers)
     * do state tato akce ulozi co ma (props.hiddenFeatureIds)
     * komponenta a jeji useEffect nezareaguje
     * -> proto tento HACK (setImmediate)
     */
    if (payload.edit) {
        setImmediate(() => {
            dispatch(actionInteractionSelectFeatures(LAYER_IDS.EDIT_TOOLS_MODIFY, editedOLFeatures.length ? [editedOLFeatures[0]] : []));
        });
    }
};
//# sourceMappingURL=selectFeature.js.map